import MainHome from "@/components/main/MainHome.vue";

import PriceView from "@/views/PriceView.vue";
import BoardView from "@/views/BoardView.vue";
import UserView from "@/views/UserView.vue";
import AlarmView from "@/views/AlarmView.vue";

import CoinFav from "@/components/price/CoinFav.vue";
import CoinUp from "@/components/price/CoinUp";
import CoinDown from "@/components/price/CoinDown";
import CoinVol from "@/components/price/CoinVol";
import CoinFavModal from "@/components/price/sub/CoinFavModal.vue";
import TradingView from "@/components/price/sub/TradingView.vue";

import AlarmDashboard from "@/components/alarm/AlarmDashboard";
import GuidePdf from "@/components/alarm/GuidePdf";
import PriceAlarm from "@/components/alarm/PriceAlarm";
import AlarmDetail from "@/components/alarm/detail/AlarmDetail";
import NextDetail from "@/components/alarm/detail/NextDetail";
import LightDetail from "@/components/alarm/detail/LightDetail";
// import RealDetail from "@/components/alarm/detail/RealDetail";
import LightSubDetail from "@/components/alarm/sub/LightSubDetail";

import CoinRsiModal from "@/components/alarm/sub/CoinRsiModal.vue";
import GuideModal from "@/components/alarm/sub/GuideModal.vue";
import AlarmRegModal from "@/components/modal/AlarmRegModal.vue";

import AiBriefDetail from "@/components/board/sub/AiBriefDetail";
import AiBrief from "@/components/board/AiBrief";
import Brief from "@/components/board/Brief";
// import BriefDetail from "@/components/board/sub/BriefDetail";
import Notice from "@/components/board/Notice";
import NoticeDetail from "@/components/board/sub/NoticeDetail";
import FAQ from "@/components/board/FAQ";

import NotFound from "@/components/NotFound";
import searchExComponent from "@/searchExComponent";
import sliderComponent from "@/sliderComponent";

import Setting from "@/components/user/Setting";
import MemberInfo from "@/components/user/MemberInfo";
import RecommendInfo from "@/components/user/RecommendInfo";
import SettingApi from "@/components/user/SettingApi.vue";
import SettingPosition from "@/components/user/SettingPosition.vue";
import SubscribeInfo from "@/components/user/SubscribeInfo.vue";
import SettingGeneral from "@/components/user/SettingGeneral.vue";
import ConfirmVer from "@/components/user/ConfirmVer.vue";
import Construction from "@/components/user/Construction.vue";

const routes = [
  { path: "/", redirect: "/home" },
  {
    path: "/home",
    component: MainHome,
  },
  {
    path: "/price",
    component: PriceView,
    redirect: "/price/favorite",
    children: [
      // {
      //   path: "favorite", 
      //   component: CoinFav,
      //   // children: [
      //   //   { path: "fav-coin", component: CoinFavModal },
      //   // ]
      // },
      // { path: "fav-coin", component: CoinFavModal },
      {
        path: "favorite",
        name: "PriceFavorite",
        component: CoinFav,
        children: [
          {
            path: "fav-coin",
            name: "PriceFavoriteCoin",
            component: CoinFavModal,
          },
        ],
      },
      { path: "up", component: CoinUp },
      { path: "down", component: CoinDown },
      { path: "volume", component: CoinVol },

    ],
  },
  {
    path: "/trading-view/:exchange/:coin/:quote", // Define a dynamic route
    name: "TradingView",
    component: TradingView,
    props: true,
  },
  {
    path: "/alarm",
    component: AlarmView,
    redirect: "/alarm/dashboard",
    children: [
      { path: "dashboard", component: AlarmDashboard },
      { path: "price", component: PriceAlarm },
      { path: "support-resistance", component: AlarmDetail },
      { path: "score", component: AlarmDetail },
      { path: "premium", component: AlarmDetail },
      { path: "smart", component: AlarmDetail },
      { path: "plus-coin", component: CoinRsiModal },
      { path: "guide", component: GuideModal },
      { path: "insight-coin", component: AlarmRegModal },
      { path: "change-coin", component: AlarmRegModal },
      { path: "next", component: NextDetail },
      { path: "goya", component: NextDetail },
      { path: "light", component: LightDetail },
      { path: "light-detail", component: LightSubDetail },
      { path: "rocket", component: AlarmDetail },
      { path: "guide-pdf", component: GuidePdf }
      // { path: "real", component: RealDetail },
    ],
  },
  {
    path: "/board",
    component: BoardView,
    redirect: "/board/ai-brief",
    children: [
      { path: "ai-brief", component: AiBrief },
      { path: ":currentTab", component: AiBriefDetail },
      { path: "brief", component: Brief },
      { path: ":boardType/:id", component: AiBriefDetail },
      { path: "notice", component: Notice },
      { path: "notice-detail/:id", component: NoticeDetail },
      { path: "faq", component: FAQ },
    ],
  },
  {
    path: "/user",
    component: UserView,
    redirect: "/user/setting",
    children: [
      { path: "setting", component: Setting },
      { path: "member-info", component: MemberInfo },
      { path: "recommend-info", component: RecommendInfo },
      { path: "subscribe-info", component: SubscribeInfo },
      { path: "connect-api", component: SettingApi },
      { path: "position", component: SettingPosition },
      { path: "setting-general", component: SettingGeneral },
      { path: "confirm-ver", component: ConfirmVer },
      { path: "construction", component: Construction },
    ],
  },
  {
    path: "/searchTest",
    component: searchExComponent,
  },
  {
    path: "/sliderTest",
    component: sliderComponent,
  },
  {
    path: "/:pathMatch(.*)*",
    component: NotFound,
  },
];

export default routes;
